import React from 'react';

import { getWorkflowConstants } from '~/common/constants/workflow';
import UserRoleSingleSelect from '~/components/Client/UserRoleSingleSelect';
import { useIntl } from 'react-intl';

const WorkflowUserRoleSingleSelect = (props) => {
  const intl = useIntl();
  const { workflowTicketRoleOptions } = getWorkflowConstants(intl);
  return (
    <UserRoleSingleSelect
      enablePortal
      {...props}
      roleOptions={workflowTicketRoleOptions}
    />
  );
};

export default WorkflowUserRoleSingleSelect;
